import { sendAnalyticsInfo } from './sendAnalytics';

export type InteractionSource = 'click' | 'hotkey' | (string & {});

interface InteractionAnalyticsParams {
  actionName: string;
  methodName: string;
  source: InteractionSource;
  eventName?: string;
}

export const interactionAnalytics = ({
  actionName,
  methodName,
  source,
  eventName = 'Interaction',
}: InteractionAnalyticsParams) => {
  return sendAnalyticsInfo({
    Event: eventName,
    Method: methodName,
    Message: `${actionName} triggered from ${source}`,
    Source: source,
    Action: actionName,
  });
};
